import { BaseListViewStore } from 'core/stores';
import { RoleStore } from 'modules/role/stores';
import { localStorageHandler } from 'core/services';
import { checkForColumnWidth, isSuperAdminOrganization } from 'core/utils';
import { action } from 'mobx';

class RoleViewStore extends BaseListViewStore {
	localStorageWidthKey = 'roles-column-width';

	constructor(rootStore) {
		super(rootStore, {
			listStore: new RoleStore(rootStore),
			routes: {
				detail: id => this.rootStore.routerStore.goTo('master.main.role.preview', { id }),
				edit: id => this.rootStore.routerStore.setQueryParams({ editId: id }),
				create: () => this.rootStore.routerStore.setQueryParams({ create: null }),
			},
			permissions: {
				update: () => this.authStore.hasPermission('coreRoleSection.update'),
				create: () => this.authStore.hasPermission('coreRoleSection.create'),
				remove: () => this.authStore.hasPermission('coreRoleSection.delete'),
				read: () => this.authStore.hasPermission('coreRoleSection.read'),
				full: () => this.authStore.hasPermission('coreRoleSection.full'),
			},
			tableData: {
				columns: [
					{
						key: 'name',
						title: 'ROLEVIEW.NAME',
						width: false,
						selected: true,
						sortable: true,
					},
					{
						key: 'description',
						title: 'ROLEVIEW.DESCRIPTION',
						width: false,
						selected: true,
						sortable: true,
					},
				],
				actions: {},
				sortObject: [],
			},
		});
		if (isSuperAdminOrganization(this.rootStore)) {
			this.rootStore.viewStore.handleSellerForChildViewStore(this);
		}
		this.queryUtility.initialize(this.findRoles);
		checkForColumnWidth(localStorageHandler.get(this.localStorageWidthKey), this.tableData.columns);
		this.setHeaderModes();
	}

	@action.bound
	findRoles = async () => {
		this.suspend();
		await this.listStore.find();
		this.resume();
	};
}

export default RoleViewStore;



// WEBPACK FOOTER //
// ./src/modules/role/stores/RoleViewStore.js